import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.error.cause.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Struct } from '@polkadot/types-codec';
/**
 * @name GenericExtrinsicPayloadUnknown
 * @description
 * A default handler for payloads where the version is not known (default throw)
 */

export var GenericExtrinsicPayloadUnknown = /*#__PURE__*/function (_Struct) {
  _inherits(GenericExtrinsicPayloadUnknown, _Struct);

  var _super = _createSuper(GenericExtrinsicPayloadUnknown);

  function GenericExtrinsicPayloadUnknown(registry, value) {
    var _this;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$version = _ref.version,
        version = _ref$version === void 0 ? 0 : _ref$version;

    _classCallCheck(this, GenericExtrinsicPayloadUnknown);

    _this = _super.call(this, registry, {});
    throw new Error("Unsupported extrinsic payload version ".concat(version));
    return _this;
  }

  return _createClass(GenericExtrinsicPayloadUnknown);
}(Struct);